import { useMemo } from "react"
import { useSelector } from "react-redux"

const useBillingDisabled = () => {
  const generalData = useSelector(state => state.billing.generalData)
  const billingAccess = useSelector(
    state => state.authentication.authenticatedUser.billing_access
  )
  return useMemo(
    () => {
      // Checks if FULLY paid.
      // If deposit required, cannot be considered Fully Paid until both Second and First payment rec'd
      // If no deposit, full_paid is the check point
      //dont do disabled if the user has billing access

      return (
        (Boolean(generalData.second_paid && generalData.first_paid) ||
          Boolean(generalData.full_paid)) &&
        !billingAccess
      )
    },
    [generalData]
  )
}

export default useBillingDisabled
